import { Button } from "reactstrap";

import { ROLES_TO_SEE_STATUS, rolesEnum } from "../Helpers/constants";
import {
  SUBCATEGORIESTOTALS,
  ERRORS,
  PRJVERSION,
} from "../../navigation/Routes";

export function getProjectList(list, role) {
  const organizations =
    list.organizationVersions ?? list.historicalOrganizationVersions;
  return organizations
    ? organizations
        .map((item) => ({
          ...item.version.project,
          status: item.status,
          instituteDescription: ROLES_TO_SEE_STATUS.includes(role)
            ? item.organization.description
            : item.version.project.instituteDescription,
          projectId: item.version.project.id,
          externalProjectId: item.version.project.projectId,
          isVerificationFailed: !!item.orgVersionValidations.find(
            (item) =>
              item.validationResult === "WARNING" ||
              item.validationResult === "ERROR",
          ),
          lastModifiedDate: item.lastModifiedDate,
          parent: item.parent,
          orgVersionId: item.id,
          organizationId: item.organization.id,
          isExternal: item.organization.isExternal,
          orgVersionInstCode: item.organization.instituteCode,
          structureId: item.version.project.structure.id,
          structureInfo: item.version.project.structure,
          startingDate: item.version.startPeriodDate,
          endingDate: item.version.endPeriodDate,
          description: item.version.description,
          projectEndingDate: item.version.project.endingDate,
          projectStartingDate: item.version.project.startingDate,
          projectExtensionDate: item.version.project.extensionDate,
        }))
        .map(({ __typename, structure, ...item }) => item)
    : list;
}

export const getSubCategoryListParams = (project) => ({
  status: project.status,
  isCloned: !!project.parent,
  projectCode: project.code,
  projectId: project.id,
  isExternal: project.isExternal,
  projectYear: project.year,
  externalProjectId: project.externalProjectId,
  organizationId: project.organizationId,
  structureInfo: project.structureInfo,
  orgVersionInstCode: project.orgVersionInstCode,
  coFinancing: project.coFinancing,
  instituteDescription: project.instituteDescription,
  projectStatus: project.status,
});

export const getVariables = (auth) => {
  const { role, instituteCode } = auth.userInfo;
  switch (role) {
    case rolesEnum.ADMIN:
    case rolesEnum.MOH:
      return null;
    case rolesEnum.PROJECT:
    case rolesEnum.USER:
      return { instituteCode };
    default:
      return null; // Handle unexpected roles safely
  }
};

export const getAdditionalColumns = (
  translate,
  navigate,
  setProjectData = () => {},
) => [
  {
    accessor: "details",
    enableColumnFilter: false,
    sortable: false,
    Cell: ({ row }) => (
      <Button
        color={"info"}
        onClick={() => {
          setProjectData(row.original);
          navigate(
            `${SUBCATEGORIESTOTALS}/${row.original.orgVersionId}/${row.original.structureId}`,
            {
              state: getSubCategoryListParams(row.original),
            },
          );
        }}
      >
        {translate("Category")}
      </Button>
    ),
  },
  {
    accessor: "error",
    enableColumnFilter: false,
    sortable: false,
    Cell: ({ row }) => (
      <Button
        color={row.original.isVerificationFailed ? "warning" : "info"}
        onClick={() => navigate(`${ERRORS}/${row.original.orgVersionId}`)}
      >
        {translate("verifyButton")}
      </Button>
    ),
  },
];

export const getHistoryColumn = (translate, navigate) => ({
  accessor: "history",
  enableColumnFilter: false,
  sortable: false,
  Cell: ({ row }) => (
    <Button
      color={"info"}
      onClick={() => {
        navigate(`${PRJVERSION}/${row.original.projectId}`, {
          state: {
            projectCode: row.original.code,
            missingheader:
              row.original.code + "\n" + row.original.instituteDescription,
          },
        });
      }}
    >
      {translate("viewHistoryButton")}
    </Button>
  ),
});
